/* global FB */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Env from '../lib/env';

const finishedRendering = () => {
  const spinner = global.document.getElementById('spinner');
  if (spinner) {
    spinner.removeAttribute('style');
    spinner.removeChild(spinner.childNodes[0]);
  }
};

let eventsSubscribed = false;

class FbLoginButton extends Component {

  componentDidMount() {
    this.onStatusChange = this.onStatusChange.bind(this);

    let interval;
    const tryInit = () => {
      if (typeof FB === 'undefined') {
        return;
      }
      if (this.props.user.currentUser) {
        clearInterval(interval);
        return;
      }
      if (! eventsSubscribed) {
        eventsSubscribed = true;
        FB.Event.subscribe('xfbml.render', finishedRendering);
        FB.Event.subscribe('auth.statusChange', this.onStatusChange);
      }

      FB.init({
        appId: Env.getCurrent().fb_app_id,
        status: true,
        xfbml: true,
        oauth: false,
        version: 'v2.12',
      });

      clearInterval(interval);
    };

    interval = setInterval(tryInit, 200);
    tryInit();
  }

  onStatusChange() {
    this.checkResponse('StatusChange');
  }

  checkResponse(eventType) {
    console.log(`FB event ${eventType}`);

    if (typeof FB !== 'undefined') {
      FB.getLoginStatus(response => {
        if (response.status === 'connected') {
          this.props.onLogin(response.authResponse.accessToken);
        }
      });
    }
  }

  render() {
    return (
      <div
        style={{
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <div
          id="spinner"
          style={{
            background: '#4267b2',
            borderRadius: '5px',
            color: 'white',
            height: '40px',
            width: '250px',
            marginTop: '20px',
          }}
        >
          &nbsp;
          <div
            className="fb-login-button"
            data-max-rows="1"
            data-size="large"
            data-button-type="continue_with"
            data-show-faces="false"
            data-auto-logout-link="false"
            data-use-continue-as="false"
            data-scope="public_profile, email"
          />
        </div>
      </div>
    );
  }
}

FbLoginButton.propTypes = {
  user: PropTypes.object.isRequired,
  onLogin: PropTypes.func,
  shouldShowlargeButton: PropTypes.bool,
};

export default FbLoginButton;



/* global FB */
// import React from 'react';

// import Env from '../lib/env';

// class FbLoginButton extends React.Component {
//   componentDidMount() {
//     this.onStatusChange = this.onStatusChange.bind(this);
//     FB.Event.subscribe('auth.statusChange', this.onStatusChange);
//     FB.init({
//       appId: Env.getCurrent().fb_app_id,
//       xfbml: true,
//       version: 'v2.8',
//     });
//     this.onStatusChange();
//   }
//   onStatusChange() {
//     FB.getLoginStatus((response) => {
//       if (response.status === 'connected') {
//         const token = response.authResponse.accessToken;
//         this.props.onLogin(token);
//       }
//     });
//   }
//   render() {
//     return (
//       <div
//         className="fb-login-button"
//         data-max-rows="1"
//         data-size="large"
//         data-show-faces="false"
//         data-auto-logout-link="true"
//       />
//     );
//   }
// }

// FbLoginButton.propTypes = {
//   onLogin: PropTypes.func,
// };

// export default FbLoginButton;



// WEBPACK FOOTER //
// ./src/components/fb-login-button.js